module.exports = __webpack_public_path__ + "static/Safeway_pin-ba07245eddef7b9e6eefee9b247709cf.png";